module.exports = __webpack_public_path__ + "img/PublicationButton.c436e082.png";